'use strict';

export default class TranslationActions {
    constructor() {
        this.generateActions(
            'addLocaleData',
            'addMessages',
            'setLanguage',
            'setAvailableLanguages'
        );
    }
}



// WEBPACK FOOTER //
// ./app/actions/translationsActions.js